import { useState } from "react"
import { CalendarIcon } from "lucide-react"
import { Button } from "@components/ui/button"
import { Calendar } from "@components/ui/calendar"
import { Popover, PopoverContent, PopoverTrigger } from "@components/ui/popover"
import { cn } from "./ui/lib/utils"

type TDatePickerProps = {
  field: {
    value: string | undefined
    onChange: (value: string) => void
  }
  disabled?: (date: Date) => boolean
}

export const DatePicker = ({ field, disabled }: TDatePickerProps) => {
  const [open, setOpen] = useState(false)
  const [date, setDate] = useState<Date | undefined>(
    field.value ? new Date(field.value) : undefined,
  )

  const handleDateChange = (date: Date | undefined) => {
    setDate(date)
    field.onChange(date ? date.toISOString() : "")
    setOpen(false)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          id="date"
          className={cn(
            !field.value && "tw:text-muted-foreground",
            "tw:justify-between tw:font-normal",
          )}
        >
          {date ? date.toLocaleDateString() : "Select date"}
          <CalendarIcon />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="tw:w-auto tw:overflow-hidden tw:p-0"
        align="start"
      >
        <Calendar
          mode="single"
          selected={date}
          captionLayout="dropdown"
          onSelect={handleDateChange}
          disabled={disabled}
        />
      </PopoverContent>
    </Popover>
  )
}
